
export class ArrayUtils {
    static arraymove<T>(arr: T[], fromIndex: number, toIndex: number) {
        const element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
    }

    static sum<T>(arr: T[], fn: (item: T, index: number) => number | undefined | null): number {
        return arr.reduce((acc, item, index) => acc + (fn(item, index) ?? 0), 0);
    }

    static length<T>(arr: T[] | undefined): number {
        return arr ? arr.length : 0;
    }

    static maxDate(arr: any[], fn: (item: any) => Date | undefined | null): Date | undefined {
        if (arr.length === 0) return undefined;
        let max: Date | undefined = undefined;
        for (const item of arr) {
            const date = fn(item);
            if (date && (!max || date > max)) max = date;
        }
        return max;
    }

    static countIf<T>(arr: T[], predicate: (item: T, index: number) => boolean): number {
        return arr.reduce((idx, item) => idx + (predicate(item, idx) ? 1 : 0), 0);
    }

    static random<T>(arr: T[]): T | undefined {
        if (arr.length === 0) return undefined;
        return arr[Math.floor(Math.random() * arr.length)];
    }
}
